import { render, staticRenderFns } from "./AddTransactionLimit.vue?vue&type=template&id=4b7e0528&scoped=true"
import script from "./AddTransactionLimit.vue?vue&type=script&lang=js"
export * from "./AddTransactionLimit.vue?vue&type=script&lang=js"
import style0 from "./AddTransactionLimit.vue?vue&type=style&index=0&id=4b7e0528&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e0528",
  null
  
)

export default component.exports